import type { WatchdogsFeatureConfig } from './type';

export const watchdogs: Partial<WatchdogsFeatureConfig> = {
    updateContentType:
        'application/vnd.at.sitsolutions.services.watchdogs.representation.watchdogs.view.item+json',
    showOverviewDescription: 'always',
    channelSelectionDisclaimer: 'general',
};
